:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.comment-item {
  display: flex;
  flex-direction: column;
  gap: var(--control-mer-control-label-vertical-spacing, 4px);
}

.comments-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-xl);
  list-style: none;
  margin: 0;
  padding: 0;
}

.divider {
  border: none;
  border-top: 1px solid var(--color-border-surface-on-elevation-1, #333d47);
  margin: 0;
}

.row {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-xl);
}

.comments-container {
  overflow-y: auto;
  flex: 1;
}

.comment-title {
  color: var(--color-text-neutral-neutral);
}
